module.exports = __webpack_public_path__ + "fonts/GlacialIndifference.2d784ba1.ttf";